import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  getBatchUploadDisplayCurrent,
  type BatchUploadProgress,
} from "./batchUploadTypes";

type BatchUploadProgressToastContentProps = {
  current: number;
  total: number;
};

export const BatchUploadProgressToastContent = ({
  current,
  total,
}: BatchUploadProgressToastContentProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 pt-0.5">
      <Loader2
        className="h-5 w-5 shrink-0 animate-spin text-primary"
        aria-hidden
      />
      <div className="flex flex-col gap-0.5 min-w-0">
        <span className="text-lg font-semibold tabular-nums leading-none">
          {current}/{total}
        </span>
        <span className="text-xs text-muted-foreground truncate">
          {t("mediaLibrary.batch.uploadToastHint")}
        </span>
      </div>
    </div>
  );
};

export function buildBatchUploadToastContent(progress: BatchUploadProgress) {
  const current = getBatchUploadDisplayCurrent(progress);
  return (
    <BatchUploadProgressToastContent
      current={current}
      total={progress.total}
    />
  );
}
